import { useMemo } from 'react'

import { NavigationAppMenuItem, NavigationAppMenuItemSeparator } from 'features/navigation/types'

import { useAppNavigationContext } from './useAppNavigationContext'

export type AppNavigationSection = {
    type: 'section'
    separator: NavigationAppMenuItemSeparator
    items: NavigationAppMenuItem[]
}

export type AppNavigationTree = (AppNavigationSection | NavigationAppMenuItem)[]

export const useAppNavigationTreeState = () => {
    const { menuItems } = useAppNavigationContext()

    const navigationTree = useMemo(() => {
        let contextSection: AppNavigationSection | null = null
        return menuItems.reduce<AppNavigationTree>((tree, item) => {
            if (item.type === 'separator') {
                contextSection = {
                    type: 'section',
                    separator: item,
                    items: [],
                }
                tree.push(contextSection)
            } else {
                if (contextSection) {
                    contextSection.items.push(item)
                } else {
                    tree.push(item)
                }
            }

            return tree
        }, [])
    }, [menuItems])

    return useMemo(
        () => ({
            navigationTree,
        }),
        [navigationTree]
    )
}
